import CreateMeetsComp from "@/components/meets/create-meets-comp"
import DefaultLayout from "@/layouts/default";

const CreateMeetingPage = () => {

return (<>
<DefaultLayout>
    <div className="relative">
        <CreateMeetsComp _onResp={null}/>
    </div>
</DefaultLayout>
</>)
}

export default CreateMeetingPage